<div>
	<div class="row">
		<div class="col-md-12" *ngIf="customer">
			<app-components-managecustomer-opentickets
				[customer]="customer"
				(refreshCustomer)="refreshCustomer.emit()"
				(reloadNotes)="notesComponent.dataTable.reload()">
			</app-components-managecustomer-opentickets>
		</div>
	</div>
	<div class="row">
		<div class="col-md-12">
			<app-components-managecustomer-customersynopsis
				[customer]="customer"
				[customerSynopsis]="customer.Synopsis"
				(refreshCustomer)="refreshCustomer.emit()">
			</app-components-managecustomer-customersynopsis>
		</div>
	</div>
	<div class="row">
		<div class="col-md-12">
			<app-tab-panel [displayMode]="tabPanelDisplayMode.horizontalCard">
				<app-tab title="Contact Notes">
					<app-components-managecustomer-notes *tabContent [customer]="customer">
					</app-components-managecustomer-notes>
				</app-tab>
				<app-dynamic-tab title="Notifications">
					<app-components-managecustomer-customer-notifications *tabContent [customerId]="customer.CustomerId">
					</app-components-managecustomer-customer-notifications>
				</app-dynamic-tab>
			</app-tab-panel>
		</div>
	</div>
</div>
